import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import config from "../../config/config";
import axios from "axios";
// import DataTable from "react-data-table-component";
// import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";

//MUI Table
import { MaterialReactTable } from "material-react-table";
// import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
// import { toastSuccess } from "../../../../common/Toast";
// import { DELETE_MESSAGE } from "../../../../common/Constant";

const FilterModal = ({ callback, runApi }) => {
  // const history = useNavigate();

  // console.log(callback, runApi, "runrun")
  const Location = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const [showModal, setShowModal] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchtext, setSearchText] = useState("");
  const [perPageSize, setperPageSize] = useState(10);
  const [sortingId, setSortingId] = useState(2);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [selectCheckbox,setSelectCheckbox] = useState(false)

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const handleRowSelected = (e) => {
    if (e?.selectedRows.length > 0) {
      // const selectedData = e.selectedRows.map((x) => x);
      setSelectedRows(e?.selectedRows);

    }
  };

  const handleClick = (row) => {
    setSelectCheckbox(true)
    // setData([])
    console.log(row, toggledClearRows, "selectedRows");
    const selectedIds = row.map((x) => ({ ...x, ReceivingId: 0 }));
    callback(row.map(el => el.original));

    // setToggleClearRows(!toggledClearRows);
    // setSelectedRows([]); // Clear selected rows
    // handleClose(); // Close the modal
  };

  useEffect(() => {
    // callback(locationItemData);
  }, [selectedRows]);

  const handleClose = () => {
    setSelectedRows([]);
    setShowModal(false);
  };

  //dropdown
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      // height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      // boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
      zIndex: 99,
    }), // dropdown menu css
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection,
      selectedTags ? selectedTags : "",
      selectedCategories ? selectedCategories : "",
      responseString ? responseString : "");
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id,
      sortingDirection, selectedTags ? selectedTags : "",
      selectedCategories ? selectedCategories : "",
      responseString ? responseString : "");
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      selectedTags ? selectedTags : "",
      selectedCategories ? selectedCategories : "",
      responseString ? responseString : ""
    );
  };
  const ChangeFilterText = (e) => {

    setSearchText(e.target.value);
    setCurrentPage(1);

    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      selectedTags ? selectedTags : "",
      selectedCategories ? selectedCategories : "",
      responseString ? responseString : "");
    // handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  // useEffect(() => {
  //   // fetchData();

  //   const timer = setTimeout(() => {
  //     // Make your API call here
  //     fetchData();
  //   }, 500); // Adjust the delay according to your needs (in milliseconds)

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [searchtext]);


  // Fetch data from an API
  // const fetchData = async () => {
  //   handleListData(1, perPageSize, searchtext, sortingId, sortingDirection,
  //     selectedTags ? selectedTags : "",
  //     selectedCategories ? selectedCategories : "",
  //     responseString ? responseString : "");
  // };

  const handleTagIds = (e) => {
    setSelectedTags(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleCategoriesIds = (e) => {
    setSelectedCategories(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleSupplierIds = (e) => {
    setSelectedSupplier(Array.isArray(e) ? e.map((x) => x.value) : []);
  };



  let tagsOption = [];
  const Tags = tagData.map((u, i) => {
    tagsOption[i] = { label: u.Name, value: u.ID };
  });
  let categoriesOption = [];
  const Categories = categoriesData.map((u, i) => {
    categoriesOption[i] = { label: u.Name, value: u.ID };
  });
  let supplierOption = [];
  const Suppliers = supplierData.map((u, i) => {
    // supplierOption[i] = { label: u.FirstName, value: u.ID };
    supplierOption[i] = { label: u.CompanyName + "(" + u.FirstName + " " + u.LastName + ")", value: u.ID };
  });

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    selectedTags,
    selectedCategories,
    responseString,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    // console.log(tag, category, supplier);
    // setCurrentPage(page);
    setLoading(true);
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        // `${config.generalBaseUrl}/generals/itemslistsearchparameter?tag=${tag}&category=${category}&supplier=${supplier}`,
        `${config.generalBaseUrl}/generals/itemslistsearchparameter?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${sorting[0]?.desc === undefined
          ? "desc"
          : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${globalFilter == undefined ? "" : globalFilter
        }&tag=${selectedTags}&category=${selectedCategories}&supplier=${responseString}&locationid=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        setTotalRows(response.data.ResponseData.customfield[0]?.TotalRecord);
        const newData = response.data.ResponseData.customfield.map((item) => ({
          ...item,
          ReceivingId: 0,
        }));
        setData(newData);
        // setTotalRows(newData.length);
        console.log("xyzres------->", response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        //  callback();
      });
  };

  useEffect(() => {
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoriesData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSupplierData(res.data.ResponseData);
        return res;
      });
  }, []);

  const responseString = selectedSupplier?.join(",");
  // console.log("selectedsupplioer===>", responseString);
  useEffect(() => {
    if (runApi) {
      handleListData(
        1,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        selectedTags ? selectedTags : "",
        selectedCategories ? selectedCategories : "",
        responseString ? responseString : "",
        columnFilters,
        globalFilter,
        pagination,
        sorting
      );
    }
    // handleListData(1);
  }, [
    // perPageSize,
    // searchtext,
    // sortingId,
    // sortingDirection,
    selectedTags,
    selectedCategories,
    responseString,
    runApi,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    // selectCheckbox
  ]);

  // Table Data
  // const columns = [
  //   {
  //     name: "ItemId",
  //     selector: (row) => (
  //       <>
  //         {row.VariationId > 0 ? row.ItemId + "#" + row.VariationId : row.ItemId}
  //       </>
  //     ),
  //     minWidth: "120px",
  //     width: "120px",
  //   },
  //   {
  //     name: "UPC/EAN/ISBN",
  //     selector: "Itemnumber",
  //     sortable: true,
  //     minWidth: "150px",
  //     width: "150px",
  //   },
  //   {
  //     name: "Item Name",
  //     selector: (row) => (
  //       <div className="word-break-data" title={row.Name}>
  //         {row.VariationName != "" ? row.VariationName : row.ItemName}
  //       </div>
  //     ),
  //     // row.VariationName != "" ? row.VariationName : row.ItemName,
  //     sortable: true,
  //     minWidth: "120px",
  //   },
  //   {
  //     name: "Category ",
  //     //selector: (row) => row.CategoryName,
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.CategoryName}>
  //         {row.CategoryName}
  //       </p>
  //     ),
  //     sortable: true,
  //     minWidth: "105px",
  //   },
  //   {
  //     name: "Cost Price",
  //     selector: (row) => parseFloat(row.CostPrice > 0 ? row.CostPrice : 0).toFixed(2),
  //     right: true,
  //     minWidth: "110px",
  //     width: "110px",

  //     // cell: (row) =>
  //     //   row.CostPrice ? `${Number(row.CostPrice).toFixed(2)}` : "",
  //   },
  //   {
  //     name: "Unit Price",
  //     selector: (row) => parseFloat(row.UnitPrice > 0 ? row.UnitPrice : 0).toFixed(2),
  //     right: true,
  //     minWidth: "110px",
  //     width: "110px",
  //     // cell: (row) =>
  //     //   row.UnitPrice ? `${Number(row.UnitPrice).toFixed(2)}` : "",
  //   },
  //   {
  //     name: "Qty.",
  //     selector: (row) =>
  //       parseFloat(row.Itemquantity !== null ? row.Itemquantity : 0).toFixed(2),
  //     right: true,
  //     minWidth: "100px",
  //     width: "100px",
  //     // cell: (row) =>
  //     //   row.itemquantity ? `${Number(row.itemquantity).toFixed(2)}` : "",
  //   },
  //   {
  //     name: "Images",
  //     // cell: (row) => {
  //     //   return (
  //     //     <>
  //     //       {/* <img src={row.ImageName} /> */}
  //     //       <img
  //     //         src={
  //     //           row.ImageName
  //     //             ? row.ImageName === "NO IMAGE"
  //     //               ? "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
  //     //               : row.ImageName
  //     //             : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
  //     //         }
  //     //         alt="Selected Image"
  //     //         style={{
  //     //           maxWidth: "50px",
  //     //           maxHeight: "50px",
  //     //           margin: "1px",
  //     //         }}
  //     //       />
  //     //     </>
  //     //   );
  //     // },
  //     minWidth: "80px",
  //     width: "80px",
  //     center: true,
  //     cell: (row) => (
  //       <>
  //         {
  //           row.ImageName != "NO IMAGE" ? (<a target="_blank" href={row.ImageName}>
  //             <img
  //               src={
  //                 row.ImageName
  //                   ? row.ImageName
  //                   : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
  //               }
  //               style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
  //             />
  //           </a>)
  //             :
  //             (<img
  //               src={
  //                 row.ImageName != "NO IMAGE"
  //                   ? row.ImageName
  //                   : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
  //               }
  //               style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
  //             />)
  //         }


  //       </>
  //     ),
  //   },
  //   {
  //     name: "Tag",
  //     selector: (row) => row.TagName,
  //     sortable: true,
  //     minWidth: "130px",
  //   },
  //   {
  //     name: "Supplier",
  //     // selector: (row) => row.SupplierName,
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.SupplierName}>
  //         {row.SupplierName != null ? row.SupplierName : ""}
  //       </p>
  //     ),
  //     sortable: true,
  //     // width: "150px",
  //     minWidth: "130px",
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "ItemId",
      accessorKey: "ItemId",
      Cell: ({ row }) => (row.original.VariationId > 0 ? row.original.ItemId + "#" + row.original.VariationId : row.original.ItemId)
    },
    {
      header: "UPC/EAN/ISBN",
      accessorKey: "Itemnumber",
    },
    {
      header: "Item Name",
      accessorKey: "ItemName",
      Cell: ({ row }) => {
        return (
          <div className="word-break-data" title={row.Name}>
            {row.original.VariationName != "" ? row.original.VariationName : row.original.ItemName}
          </div>
        )
      }
    },
    {
      header: "Category",
      accessorKey: "CategoryName",
    },
    {
      header: "Cost Price",
      accessorKey: "CostPrice",
      Cell: ({ row }) => (parseFloat(row.original.CostPrice > 0 ? row.original.CostPrice : 0).toFixed(2))
    },
    {
      header: "Unit Price",
      accessorKey: "UnitPrice",
      Cell: ({ row }) => (parseFloat(row.original.UnitPrice > 0 ? row.original.UnitPrice : 0).toFixed(2))
    },
    {
      header: "Qty.",
      accessorKey: "Itemquantity",
      Cell: ({ row }) => parseFloat(row.original.Itemquantity !== null ? row.original.Itemquantity : 0).toFixed(2)
    },
    {
      header: "Images",
      accessorKey: "ImageName",
      Cell: ({ row }) => {
        return (
          <>
            {
              row.original.ImageName != "NO IMAGE" ? (<a target="_blank" href={row.original.ImageName}>
                <img
                  src={
                    row.original.ImageName
                      ? row.original.ImageName
                      : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                  }
                  style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
                />
              </a>)
                :
                (<img
                  src={
                    row.original.ImageName != "NO IMAGE"
                      ? row.original.ImageName
                      : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                  }
                  style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
                />)
            }
          </>
        )
      }
    },
    {
      header: "Tag",
      accessorKey: "TagName"
    },
    {
      header: "Supplier",
      accessorKey: "SupplierName",
      Cell: ({ row }) => {
        return (
          <p className="word-break-data" title={row.original.SupplierName}>
            {row.SupplierName != null ? row.SupplierName : ""}
          </p>
        )
      }
    }
  ]);

  return (
    <>
      <Loader loading={loading} />
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Filter
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="form-group col-md-4">
                  <label className="form-label">Tags</label>
                  <div className="input-group">
                    {/* <span className="input-group-text">
                      <i
                        className="fa fa-tags"
                        data-bs-toggle="tooltip"
                        title="fa fa-tags"
                      ></i>
                    </span> */}

                    <Select
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isMulti={true}
                      isClearable={true}
                      onChange={handleTagIds}
                      options={tagsOption}
                      placeholder="Select Tags"
                      styles={selectStyles}
                      value={tagsOption.filter((obj) =>
                        selectedTags.includes(obj.value)
                      )}
                      id="TagsIds"
                      name="TagsIds"
                      className="w-100"
                    />
                  </div>
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">Categories</label>
                  <div className="input-group">
                    {/* <span className="input-group-text">
                      <i className="fa fa-th-list" data-bs-toggle="tooltip"></i>
                    </span> */}

                    <Select
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isMulti={true}
                      isClearable={true}
                      onChange={handleCategoriesIds}
                      options={categoriesOption}
                      placeholder="Select Category"
                      styles={selectStyles}
                      value={categoriesOption.filter((obj) =>
                        selectedCategories.includes(obj.value)
                      )}
                      id="CategoriesIds"
                      name="CategoriesIds"
                      className="w-100"
                    />
                  </div>
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">Suppliers</label>
                  <div className="input-group">
                    {/* <span className="input-group-text">
                      <i
                        className="fa fa-industry"
                        data-bs-toggle="tooltip"
                      ></i>
                    </span> */}

                    <Select
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isMulti={true}
                      isClearable={true}
                      onChange={handleSupplierIds}
                      options={supplierOption}
                      placeholder="Select Supplier"
                      styles={selectStyles}
                      value={supplierOption.filter((obj) =>
                        selectedSupplier.includes(obj.value)
                      )}
                      id="SupplierIds"
                      name="SupplierIds"
                      className="w-100"
                    />
                  </div>
                </div>
                {/* <div className="form-check form-switch col-md-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="toggle-button"
                  />
                  <label className="form-check-label" htmlFor="toggle-button">
                    Is Favourite
                  </label>
                </div> */}

              </div>
              <div className="row">
                <div className="form-group col-md-4">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="form-control form-control-sm"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  />
                </div>
                <div className="form-group col-md-4">
                </div>
                {/* <div className="form-group col-md-4 text-right">
                  <button
                    type="Submit"
                    className="btn btn-sm btn-outline-primary pull-right"
                    data-bs-dismiss="modal"
                  // onClick={handleClick}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    Add
                  </button>
                </div> */}
              </div>
            </div>
            {/* <div>
              <DataTable
                columns={columns}
                data={data}
                fixedHeaderScrollHeight="600px"
                fixedHeader
                // progressPending={loading}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={(e) => {
                  handlePerRowsChange(1, e);
                }}
                onChangePage={handlePageChange}
                highlightOnHover
                striped
                responsive
                paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                persistTableHead
                selectableRows
                sortServer
                onSort={handleSort}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggledClearRows}
                dense
              />
            </div> */}

            <MaterialReactTable
              columns={columns}
              data={data}
              // tableRef={tableRef}
              enableColumnResizing
              // enableRowActions
              // renderRowActionMenuItems={({ row }) => [
              //   <MenuItem
              //     key="edit"
              //     onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}
              //   >
              //     Edit
              //   </MenuItem>,
              //   <MenuItem
              //     className="confirm-text"
              //     to="#"
              //     // key="delete"
              //     title="Delete"
              //     data-bs-toggle="modal"
              //     data-bs-target="#DeleteConfirmationModal"
              //     onClick={() => handleDeletePopup(row.original.ID, "", "")}
              //   >
              //     Delete
              //   </MenuItem>,
              //   row.original.Attachements ? (
              //     <a
              //       className="dropdown-item confirm-text"
              //       href={row.original.Attachements}
              //       target="_blank"
              //       title="Attachment"
              //     >
              //       <MenuItem title="Attachment">Attachments</MenuItem>
              //     </a>
              //   ) : (
              //     ""
              //   ),
              // ]}
              enableGrouping
              enableStickyHeader
              enableStickyFooter
              enableRowSelection
              enableColumnOrdering
              // autoResetAll = {selectCheckbox}
              initialState={{
                density: "compact",
                expanded: true, //expand all groups by default
                // grouping: [""], //an array of columns to group by by default (can be multiple)
                pagination: { pageIndex: 0, pageSize: 25 },
                sorting: [{ id: "state", desc: false }], //sort by state by default
              }}
              // muiToolbarAlertBannerChipProps={{ color: "primary" }}
              // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
              muiTablePaginationProps={{
                rowsPerPageOptions: [10, 25, 50, 100, 300, 500],
              }}
              muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
              // manualFiltering
              manualPagination
              manualSorting
              muiToolbarAlertBannerProps={
                isError
                  ? {
                    color: "error",
                    children: "Error loading data",
                  }
                  : undefined
              }
              // onColumnFiltersChange={setColumnFilters}
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              rowCount={totalRows}
              state={{
                // columnFilters,
                globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
              }}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    p: "0.5rem",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    size="small"
                    // className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() =>
                      handleClick(table.getSelectedRowModel().rows)
                    }
                    // startIcon={<FileDownloadIcon />}
                    variant="contained"
                  >
                    Add
                  </Button>
                </Box>
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterModal;
